import { FormControl, FormGroup, Validators } from '@angular/forms'

import { PaiValidators } from 'app/utils/forms/pai-validators'
import { FormGroupValueTypeHelper } from 'app/utils/types/form-group-type-helper.type'

const controls = () => ({
  name: new FormControl(null, [PaiValidators.requiredString, Validators.minLength(3), Validators.maxLength(100)]),
  email: new FormControl(null, [PaiValidators.requiredString, PaiValidators.email]),
  message: new FormControl(null, [PaiValidators.requiredString, Validators.minLength(10)]),
})

export class ContactForm extends FormGroup<ReturnType<typeof controls>> {
  declare value: FormGroupValueTypeHelper<ReturnType<typeof controls>>

  constructor() {
    super(controls())
  }
}
